// components/PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { getAuth } from "firebase/auth";
import app from "../firebase";

const auth = getAuth(app);

export default function PrivateRoute({ children }) {
  const user = auth.currentUser;
  return user ? children : <Navigate to="/admin-login" replace />;
}
